import { Grid, List, ListItem, ListItemText, Typography } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import { useState } from "react";
import "./css/AccountDetailsMenu.scss";
import Divider from "@mui/material/Divider";
import { useHistory } from "react-router-dom";
import { IBroadbandSubscription } from "@pages/AccountDetails/interface/IAccountDetailsPage";
import { getAccountDetailsMenu } from "./utils";

interface IParams {
    broadbandSubscription?: IBroadbandSubscription;
    hasActiveOfferDetails: boolean;
}

interface IOfferMenuItem {
    externalUrl?: string;
    isBlockedIfNoService: boolean;
    title: string;
    url?: string;
}

export const AccountDetailsMenu = (props: IParams) => {
    const { broadbandSubscription, hasActiveOfferDetails } = props;
    const [isActionAvailable, setIsActionAvailable] = useState(true);
    const history = useHistory();

    const linkOnClickAction = (menuItem: IOfferMenuItem) => {
        if (!hasActiveOfferDetails && menuItem.isBlockedIfNoService) {
            setIsActionAvailable(false);
        } else {
            setIsActionAvailable(true);
            if (menuItem.externalUrl) {
                window.location.href = menuItem.externalUrl;
            }
            if (menuItem.url) {
                history.push(menuItem.url);
            }
        }
    };

    return (
        <div className="offer-menu">
            {!isActionAvailable && (
                <Grid container spacing={1} wrap="wrap">
                    <Grid item sm={6} xs={12}>
                        <Typography>This action is unavailable until your service is activated.</Typography>
                    </Grid>
                </Grid>
            )}
            <List component="nav">
                <Grid container spacing={1} wrap="wrap">
                    {getAccountDetailsMenu(broadbandSubscription).map((menuItem) => (
                        <Grid item key={menuItem.title} sm={6} xs={12}>
                            <ListItem button onClick={() => linkOnClickAction(menuItem)}>
                                <ListItemText color="primary" primary={menuItem.title} />
                                <KeyboardArrowRight />
                            </ListItem>
                            <Divider light />
                        </Grid>
                    ))}
                </Grid>
            </List>
        </div>
    );
};
